module.exports = __webpack_public_path__ + "static/2006-layer-3-2094bb5832f6feac18740ed7205c4bfe.png";